export enum KnowAbout {
    INSTAGRAM = "I",
    FACEBOOK = "F",
    SITE = "S",
    PASTOR = "P",
    MEETING = "R",
    OTHER = "O"
}